import palette from "../palette";

const MuiTableRow = {
	root: {
		"&.Mui-selected": {
			backgroundColor: palette.background.default,
		},
		"&.MuiTableRow-hover": {
			"&:hover": {
				backgroundColor: palette.background.default,
			},
		},
	},
};

export default MuiTableRow;
